/**
 * The Permission that reads every Account's quota usage and Requests, as the
 * backend's `Permission.QUOTA_READ_ANY` names it: the Settings Usage panel and
 * the Requests tab take it.
 */
export const QUOTA_READ_ANY = "quota:read_any"
